import { AppConfigService } from '../services/config.service';
// Angular
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addApiUrlBeforePath',
  standalone: true,
})
export class AddApiUrlBeforePathPipe implements PipeTransform {
  constructor() {}

  transform(value: string, args?: any): any {
    if (value) return AppConfigService.config.apiUrl + '/' + value;
  }
}
